import { combineReducers } from 'redux';

import administration from './administration/administrationReducer';
import agence from './agence/agenceReducer';
import articleGestion from './articleGestion/articleGestionReducer';
import articlesGestion from './articleGestion/articlesGestionReducer';
import categorie from './categorie/categorieReducer';
import client from './client/clientReducer';
import colisLogistique from './colisLogistique/colisLogistiqueReducer';
import common from './common/commonReducer';
import depotGestion from './depotGestion/depotGestionReducer';
import details from './reclamation/detailsReducer';
import fournisseur from './fournisseur/fournisseurReducer';
import groupe from './groupe/groupeReducer';
import information from './information/logistiqueReducer';
import pieceGestion from './pieceGestion/pieceGestionReducer';
import pieceGestionLigne from './pieceGestionLigne/pieceGestionLigneReducer';
import qualification from './qualification/qualificationReducer';
import reclamations from './reclamation/reclamationsReducer';
import reclamationIndicateurs from './reclamation/indicateursReducer';
import souffrancesTransporteur from './souffranceTransporteur/souffranceTransporteurReducer';
import suiviColis from './suiviColis/suiviColisReducer';
import transporteur from './transporteur/transporteurReducer';
import types from './type/typesReducer';
import typeIndicateurs from './type/indicateursReducer';
import utilisateurs from './utilisateur/utilisateursReducer';
import utilisateurCourant from './utilisateur/courantReducer';
import utilisateurIndicateurs from './utilisateur/indicateursReducer';
import representant from './representant/representantReducer';

export const reducers = {
    administration,
    agence,
    articleGestion: combineReducers({
        details: articleGestion,
        articlesGestion: combineReducers({
            searchFilters: articlesGestion('searchFilters'),
            addAction: articlesGestion('addAction'),
            addReclamation: articlesGestion('addReclamation'),
            administration: articlesGestion('administration')
        })
    }),
    categorie,
    client: combineReducers({
        addReclamation: client('addReclamation'),
        searchFilters: client('searchFilters'),
        informationLogistique: client('informationLogistique'),
        administration: client('administration')
    }),
    colisLogistique,
    common,
    depotGestion,
    fournisseur: combineReducers({
        addReclamation: fournisseur('addReclamation'),
        searchFilters: fournisseur('searchFilters'),
        administration: fournisseur('administration')
    }),
    groupe,
    information,
    pieceGestion: combineReducers({
        addReclamation: pieceGestion('addReclamation'),
        informationLogistique: pieceGestion('informationLogistique')
    }),
    pieceGestionLigne,
    qualification,
    reclamation: combineReducers({
        reclamations: reclamations,
        indicateurs: reclamationIndicateurs,
        details: details
    }),
    souffrancesTransporteur,
    suiviColis,
    transporteur,
    type: combineReducers({
        types: types,
        indicateurs: typeIndicateurs
    }),
    utilisateur: combineReducers({
        courant: utilisateurCourant,
        indicateurs: utilisateurIndicateurs,
        utilisateurs: combineReducers({
            affectationReclamation: utilisateurs('affectationReclamation'),
            clotureReclamation: utilisateurs('clotureReclamation'),
            observateurReclamation: utilisateurs('observateurReclamation'),
            searchFiltersEmetteur: utilisateurs('searchFiltersEmetteur'),
            searchFiltersUtilisateur: utilisateurs('searchFiltersUtilisateur'),
            searchFiltersUtilisateurPreneurOrdre: utilisateurs('searchFiltersUtilisateurPreneurOrdre'),
            searchFiltersObservateur: utilisateurs('searchFiltersObservateur'),
            administrationGroupes: utilisateurs('administrationGroupes'),
            administrationInterlocuteursSAV: utilisateurs('administrationInterlocuteursSAV'),
            administrationFeatureFlags: utilisateurs('administrationFeatureFlags'),
        })
    }),
    representant: combineReducers({
        administration: representant('administration')
    })
};